<main class="text-start">

    <div class="gray-section">

        <div class="white-rounded-container mt-3">
            <div class="flex bg-[#F7F7F7] p-3 rounded-lg justify-between">

                <div class="ps-2 sm:block hidden">
                    <p class="text-[#8E8E8E] xl:text-sm text-xs">{{ 'reviews.reviews_total' | translate }}</p>
                    <p class="mt-5 xl:text-base text-xs">{{ getRatingsSummary().totalCount }} {{ 'reviews.review_unit' | translate }}</p>
                </div>

                <div class="border-s border-gray-300 ps-5 sm:block hidden">
                    <p class="text-[#8E8E8E] xl:text-sm text-xs">{{ 'reviews.rating_average' | translate }}</p>
                    <p class="mt-5 xl:text-base text-xs">{{ getRatingsSummary().average}} <i class="bi bi-star-fill text-yellow-400"></i></p>
                </div>

                <!-- Ratings Breakdown -->
                <div
                    class="xl:space-y-3 space-y-1.5 xl:w-1/3 sm:w-2/4 w-full border-s-0 sm:border-s border-gray-300 ps-2 sm:ps-5 sm:py-0 py-2 sm:pe-0 pe-2">
                    <div *ngFor="let rating of ratings" class="flex flex-row-reverse items-center gap-2">
                        <span class="w-8 text-sm text-gray-600">{{ rating.count }}</span>
                        <div class="flex-1 flex justify-start bg-gray-200 rounded-full h-2">
                            <div class="h-2 rounded-full" [ngClass]="rating.color"
                                [style.width.%]="(rating.count / getRatingsSummary().totalCount) * 100">
                            </div>
                        </div>
                        <span class="flex items-center gap-1 text-sm text-gray-600">
                            <span class="text-yellow-400"><i class="bi bi-star-fill"></i></span>{{ rating.star }}
                        </span>
                    </div>
                </div>
            </div>


            <p class="text-[#4B4B4B] font-medium text-sm mt-5">{{ 'reviews.section_title' | translate }}</p>
            <div>
                <table class="reviews-table" *ngIf="vendorReviews">
                    <tbody>
                        <tr *ngFor="let review of vendorReviews.results">
                            <td colspan="2" class="flex justify-start items-start">
                                <div class="w-full flex flex-col md:flex-row justify-start md:items-center gap-3">
                                    <img src="dashboard/place-holders/avatar-male.png"
                                        class="xl:w-10 w-8 xl:h-10 h-8  pt-1 rounded-full bg-[#ADE4FF]">
                                    <div class="flex items-center">
                                        <p class="text-[#2F3541] me-2">{{ review.name }}</p>
                                    </div>
                                </div>
                            </td>
                            <td colspan="2">
                                <div class="xl:text-base text-sm">
                                    <i class="bi bi-star-fill" [ngClass]="review.rating >= 1 ? 'text-[#FACA15]' : 'text-[#D1D5DB]'"></i>
                                    <i class="bi bi-star-fill" [ngClass]="review.rating >= 2 ? 'text-[#FACA15]' : 'text-[#D1D5DB]'"></i>
                                    <i class="bi bi-star-fill" [ngClass]="review.rating >= 3 ? 'text-[#FACA15]' : 'text-[#D1D5DB]'"></i>
                                    <i class="bi bi-star-fill" [ngClass]="review.rating >= 4 ? 'text-[#FACA15]' : 'text-[#D1D5DB]'"></i>
                                    <i class="bi bi-star-fill" [ngClass]="review.rating >= 5 ? 'text-[#FACA15]' : 'text-[#D1D5DB]'"></i>
                                </div>
                                <p> {{ review.comment }} </p>
                            </td>
                            <td colspan="1" [ngClass]="languageService.isRtl() ? 'text-start' : 'text-end'" class="xl:text-base text-sm" dir="ltr"> {{ review.date | date: 'short'}} </td>
                        </tr>
                    </tbody>
                </table>
                <app-table-pagination *ngIf="vendorReviews" [count]="vendorReviews.count" [limit]="pagination.limit" [offset]="pagination.offset" (pageChange)="updatePagination($event)" />
            </div>
        </div>
    </div>
</main>
